import { SITE } from "@/lib/site";

/**
 * Social preview-afbeeldingen (1200x630) staan als statische bestanden in
 * /public/og. Per betaalmethode tonen ze het officiële betaallogo; de
 * homepage gebruikt de zwevende betaallogo-visual.
 */
export function ogImage(name: string): string {
  return `${SITE.url}/og/${name}.jpg`;
}

/** og:image + twitter:image meta-tags voor een pagina. */
export function ogImageMeta(name: string) {
  const url = ogImage(name);
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: `${SITE.name} — casino betaalmethoden` },
    { name: "twitter:image", content: url },
  ];
}

/** Betaalmethoden met een eigen logo-preview. */
const METHOD_OG = new Set([
  "ideal",
  "trustly",
  "sofort",
  "apple-pay",
  "google-pay",
  "skrill",
  "revolut",
  "neteller",
  "paypal",
  "paysafecard",
  "hipay",
  "visa",
  "mastercard",
  "creditcard",
  "klarna",
  "muchbetter",
  "neosurf",
  "afterpay-casinos",
  "telefoonrekening",
]);

export function methodOgMeta(slug: string) {
  return ogImageMeta(METHOD_OG.has(slug) ? slug : "betaalmethoden");
}
